// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.properties-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 2rem;
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
}

.property-card {
    border: 1px solid var(--color-light-blue);
    border-radius: 8px;
    padding: 1.5rem;
    background: white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.property-card h3 {
    margin: 0 0 1rem;
    color: #333;
    font-size: 1.25rem;
}

.property-address {
    color: #666;
    margin-bottom: 1rem;
    font-size: 0.9rem;
}

.property-price {
    color: #2c5282;
    font-weight: bold;
    font-size: 1.2rem;
    margin-bottom: 1rem;
}

.property-details {
    display: flex;
    gap: 1rem;
    color: #666;
    font-size: 0.9rem;
}

.property-details span {
    background: #f7fafc;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
}
.property-image-container img{
    max-height: 250px;
    max-width: -webkit-fill-available;
}`, "",{"version":3,"sources":["webpack://./assets/css/PropertyCard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,iCAAiC;AACrC","sourcesContent":[".properties-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 2rem;\n    padding: 2rem;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.property-card {\n    border: 1px solid var(--color-light-blue);\n    border-radius: 8px;\n    padding: 1.5rem;\n    background: white;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.property-card h3 {\n    margin: 0 0 1rem;\n    color: #333;\n    font-size: 1.25rem;\n}\n\n.property-address {\n    color: #666;\n    margin-bottom: 1rem;\n    font-size: 0.9rem;\n}\n\n.property-price {\n    color: #2c5282;\n    font-weight: bold;\n    font-size: 1.2rem;\n    margin-bottom: 1rem;\n}\n\n.property-details {\n    display: flex;\n    gap: 1rem;\n    color: #666;\n    font-size: 0.9rem;\n}\n\n.property-details span {\n    background: #f7fafc;\n    padding: 0.25rem 0.5rem;\n    border-radius: 4px;\n}\n.property-image-container img{\n    max-height: 250px;\n    max-width: -webkit-fill-available;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
